import {
  INITIALIZE_TAM_SUCCESS, TAM_SCRIPT_DISABLED,
  TAM_SCRIPT_LOAD_ERROR,
  TAM_SCRIPT_LOAD_TIMEOUT,
  UPDATE_ADVERT_SLOT,
  LOAD_ADVERTS,
  ADVERT_BIDS_REQUESTED, GPT_FALLBACK_TIMER_ID
} from "../middleware/tamGptInitialization";

export default function reducer(state = {initializationComplete: false, tamAvailable: false, advertSlots: {}}, action = {}) {
  if (action.type === INITIALIZE_TAM_SUCCESS) {
    console.log("TAM enabled");
    return {...state, initializationComplete: true, tamAvailable: true};
  }

  if ([TAM_SCRIPT_DISABLED, TAM_SCRIPT_LOAD_ERROR, TAM_SCRIPT_LOAD_TIMEOUT].includes(action.type)) {
    console.log("TAM Disabled: " + action.type.toLowerCase().replace("_", " "));
    return {...state, initializationComplete: true, tamAvailable: false};
  }

  if (action.type === UPDATE_ADVERT_SLOT) {
    return {...state, advertSlots: {...state.advertSlots, [action.slotId]: action.status}};
  }

  if (action.type === LOAD_ADVERTS) {
    return {...state, advertSlots: {...state.advertSlots, [action.slotId]: ADVERT_BIDS_REQUESTED }};
  }

  if (action.type === GPT_FALLBACK_TIMER_ID) {
    return {...state, gptTimeoutId: action.timeoutID};
  }

  return state;
}



// WEBPACK FOOTER //
// ./modules/Common/reducers/tamGpt.js